import styled from 'styled-components';

import Tooltip from '@ui/tooltip';

export const Wrapper = styled.div`
  grid-area: header;
  padding: 15px;
  background-color: #000;
`;
export const Title = styled.div`
  color: var(--color-widgetText);
  font-size: 16px;
`;

export const SearchBarStyled = styled.div`
  width: 100%;
  background: var(--color-widgetText-10);
  border-radius: 8px;
  display: flex;
  padding: 6px;
  align-items: center;
`;

export const NavBarMobileStyled = styled(SearchBarStyled)`
  padding: 4px 6px;
`;

export const InputWrapperStyled = styled.div`
  width: 100%;
  display: flex;
  border-radius: 8px;
  align-items: center;
  outline: ${({ $isSearchFocused }) => ($isSearchFocused ? `2px solid var(--color-widgetText-25)` : 'none')};
`;

export const SearchToolTipStyled = styled(Tooltip)`
  margin-inline-end: 2px;
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchButton = styled.button`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background: transparent;
  &:focus-visible {
    border-radius: 4px;
  }
  margin-inline-end: 2px;
`;

export const SearchIcon = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;
